module.exports = __webpack_public_path__ + "img/filter-style.86198858.svg";